export const setItem = (key, item) => {
  try {
    localStorage.setItem(key, item)
  } catch (e) {
    localStorage.setItem(key, JSON.stringify(item))
  }
}

export const removeKey = (item) => {
  localStorage.removeItem(item)
}

export const getItem = (key) => {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return JSON.parse(localStorage.getItem(key))
  }
}

export const clearLocalStorage = () => {
  localStorage.clear()
}

export const removeItems = (items) => {
  items.forEach((item) => localStorage.removeItem(item))
}

export const setItems = (items) => {
  items.forEach((item) => setItem(item.key, item.value))
}
